/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCos } from '../../factoriesAny.js';
export var cosDependencies = {
  typedDependencies,
  createCos
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesCos.generated.js
// module id = null
// module chunks = 